export default {
  detail: {},
  isFetching: false,
  loading: false,
  error: ""
};
